import type { LoaderSize } from "@workspace/frontend-ui";
import type Sizes from "../types/Sizes";

const getLoaderSize = (size?: Sizes): LoaderSize => {
  if (size === "xs") {
    return "2xs";
  }
  return "xs";
};

export default getLoaderSize;
